import settingRoutes from './routes';
import settingsSlice from './store/settings.store';

export { settingRoutes };

const moduleConfig = {
  routes: settingRoutes,
  reducers: {
    settings: settingsSlice.reducer,
  },
};

export default moduleConfig;
